import React, { ReactNode } from 'react'

export const Title = ({ children }: { children: ReactNode }) => {
  return <div className="text-sm text-fourth font-semibold">{children}</div>
}

export const StrongTitle = ({ children }: { children: ReactNode }) => {
  return <div className="text-sm text-white font-semibold">{children}</div>
}
